<template>
  <section class="section-sponsors" :style="{ '--sponsors-background-color': template.backgroundColor, '--sponsors-text-color': template.textColor}">
    <div class="sponsors-title">
      <h1>{{ template.title }}</h1>
    </div>
    <div class="sponsor-list">
      <div class="sponsours-box" v-for="(sponsor, i) in template.sponsors" :key="i">
        <img :src="sponsor" alt="sponsor" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Sponsors',

  data() {
    return {
      template: null,
    };
  },

  beforeMount() {
    this.template = this.$store.state.template.home.sponsors;
  },
};
</script>

<style lang="scss">
.section-sponsors {
  position: relative;
  background-color: var(--sponsors-background-color);
  width: 100vw;
  height: 100%;
  padding: 1% 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sponsors-title {
  position: relative;
  align-self: flex-start;
  margin-top: 2%;
  width: auto;
  border-bottom: 1px solid var(--sponsors-text-color);
  h1 {
    color: var(--sponsors-text-color);
    font-size: 32px;
    letter-spacing: 2px;
    text-align: left;
    margin-bottom: 0;
  }
}

.sponsor-list {
  position: relative;
  width: 100%;
  display: flex;
  // justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;

  .sponsours-box {
    padding: 1%;
    display: flex;

    img {
      position: relative;
      height: 50px;
      width: auto;
      // border-radius: 5px;
    }
  }
}
</style>